<template>
  <form-section-checkbox
    v-model="event_mode"
    :title="$t('CampaignForm_Events_Delay_Title')"
    :description="$t('CampaignForm_Events_Delay_Description')"
    :is-changed="model.diff && model.diff.includes('eventDelay')"
  >
    <form-item :label="$t('CampaignForm_Events_Delay_Delay')">
      <div style="display: flex">
        <el-input-number
          class="delay-input-number"
          v-model="model.event_delay_time"
          v-if="model.event_delay_period !== 'saved'"
          :controls="false"
          :min="0"
          :max="1000"
          style="width: 90px; margin-right: 10px"
        />
        <el-select v-model="model.event_delay_period" style="width: 200px;">
          <el-option
            value="seconds"
            :label="$t('CampaignForm_Events_Delay_Seconds')"
          />
          <el-option
            value="minutes"
            :label="$t('CampaignForm_Events_Delay_Minutes')"
          />
          <el-option
            value="hours"
            :label="$t('CampaignForm_Events_Delay_Hours')"
          />
          <el-option
            value="days"
            :label="$t('CampaignForm_Events_Delay_Days')"
          />
          <el-option
            value="saved"
            :label="$t('CampaignForm_Events_Delay_EventSaved')"
          />
        </el-select>
      </div>
    </form-item>
  </form-section-checkbox>
</template>

<script>
import FormItem from '@/common/components/form/FormItem'
import FormSectionCheckbox from '@/common/components/form/FormSectionCheckbox'
export default {
  name: 'Delay',

  components: {
    FormSectionCheckbox,
    FormItem
  },

  props: {
    model: {
      type: Object
    }
  },

  data() {
    return {
      event_mode: 0
    }
  },

  watch: {
    event_mode: function(value) {
      this.model.event_mode = value + 1
    }
  },

  mounted() {
    if (
      !Number.isNaN(this.model.event_mode) &&
      parseInt(this.model.event_mode) === 2
    ) {
      this.event_mode = 1
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/events/Delay.vue